export const config = {
    "pic1_1": {
        author: ['Malina00000ooooo'],
        description : [
            "מיכל אשל, בתו של בנימין-זאב (טדי) וייץ ז\"ל",
            "לעמוד האישי באתר ״יזכור״"
        ],
        link: ['https://www.izkor.gov.il/%D7%91%D7%A0%D7%99%D7%9E%D7%99%D7%9F-%D7%96%D7%90%D7%91%20%D7%95%D7%99%D7%99%D7%A5/en_c78b64f7547b6d0f51f12b56dc953060'],
        painting: './pic1.png',
        smallPainting : './pic1.png',
    },
    "pic2_1": {
        author: ['1111111Malina'],
        description : [
            "ציפי לוצקי, אלמנתו של יחזקאל (חזי) לוצקי ז\"ל",
            "לעמוד האישי באתר ״יזכור״"
        ],
        link: ['https://www.izkor.gov.il/%D7%99%D7%97%D7%96%D7%A7%D7%90%D7%9C%20%D7%9C%D7%95%D7%A6%D7%A7%D7%99/en_70d1dde835fd152db73a159a7efaf094'],
        painting: './pic2.png',
        smallPainting : './pic2.png',
    },
    "pic3_1": {
        author: ['1qazxcvMalina'],
        description : [
            "אוריאל וינברג, אביו של דרור-יצחק וינברג ז\"ל",
            "לעמוד האישי באתר ״יזכור״"
        ],
        link: ['https://www.izkor.gov.il/%D7%93%D7%A8%D7%95%D7%A8-%D7%99%D7%A6%D7%97%D7%A7%20%D7%95%D7%99%D7%A0%D7%91%D7%A8%D7%92/en_33ff7755be1edead5cab9adb2deebbd3'],
        painting: './pic3.png',
        smallPainting : './pic3.png',
    },
    "pic4_1": {
        author: ['1hhhvvvMalina'],
        description : [
            "חלימה אבו סבית, אלמנתו של כאמל (נביה) אבו סבית ז\"ל",
            "לעמוד האישי באתר ״יזכור״"        ],
        link: ['https://www.izkor.gov.il/%D7%9B%D7%90%D7%9E%D7%9C%20%D7%90%D7%91%D7%95%20%D7%A1%D7%91%D7%99%D7%AA/en_0dd56373dcf4847ec59dd32adc3fef60'],
        painting: './pic4.png',
        smallPainting : './pic4.png',
    },
    "pic5_1": {
        author: ['Malina'],
        description : [
            "נגה יודקוביק עציוני, בתו של שמעון יודקוביק ז\"ל",
            "לעמוד האישי באתר ״יזכור״"        ],
        link: ['https://www.izkor.gov.il/%D7%A9%D7%9E%D7%A2%D7%95%D7%9F%20%D7%99%D7%95%D7%93%D7%A7%D7%95%D7%91%D7%99%D7%A7/en_0fe3148bbe66546fb0496012a1a86dea'],
        painting: './pic5.png',
        smallPainting : './pic5.png',
    },
    "pic6_1": {
        author: ['MalinAAAAa'],
        description : [
            "סברין קאזמל חסאן, אחותו של אשרף קאזמל ז\"ל",
            "לעמוד האישי באתר ״יזכור״"        ],
        link: ['https://www.izkor.gov.il/%D7%90%D7%A9%D7%A8%D7%A3%20%D7%A7%D7%90%D7%96%D7%9E%D7%9C/en_711e5fc8a1dd36f01b6588f06207f28c'],
        painting: './pic6.png',
        smallPainting : './pic6.png',
    },
    "pic7_1": {
        author: ['MalinaBBBB'],
        description : [
            "מחמוד עוקלה, בנו של נור עוקלה ז\"ל",
            "לעמוד האישי באתר ״יזכור״"        ],
        link: ['https://www.izkor.gov.il/%D7%A0%D7%95%D7%A8%20%D7%A2%D7%95%D7%A7%D7%9C%D7%94/en_7a38375c310d2f10f351d9daa8d64f84'],
        painting: './pic7.png',
        smallPainting : './pic7.png',
    },
    "pic8_1": {
        author: ['MaliBNBNBNna'],
        description : [
            "שושנה רובין, אמה של אבישג (שגי) טויטו ז\"ל",
            "לעמוד האישי באתר ״יזכור״"        ],
        link: ['https://www.izkor.gov.il/%D7%90%D7%91%D7%99%D7%A9%D7%92%20%D7%98%D7%95%D7%99%D7%98%D7%95/en_9d772942ca2da8640d43bb694ca15f6f'],
        painting: './pic8.png',
        smallPainting : './pic8.png',
    },
    "pic9_1": {
        author: ['MMAMAalina'],
        description : [
            "אנה שרעבי, אלמנתו של מיכאל (מיקי) שרעבי ז\"ל",
            "לעמוד האישי באתר ״יזכור״"        ],
        link: ['https://www.izkor.gov.il/%D7%9E%D7%99%D7%9B%D7%90%D7%9C%20%D7%A9%D7%A8%D7%A2%D7%91%D7%99/en_3c1ca121d436fd68570173f864a7cd2f'],
        painting: './pic9.png',
        smallPainting : './pic9.png',
    },
    "pic10_1": {
        author: ['MPAPAalina'],
        description : [
            "רוברטו הופמן, אביו של אלחנדרו (אלה) הופמן ז\"ל",
            "לעמוד האישי באתר ״יזכור״"
        ],
        link: ['https://www.izkor.gov.il/%D7%90%D7%9C%D7%97%D7%A0%D7%93%D7%A8%D7%95-%D7%90%D7%9C%D7%94%20%D7%94%D7%95%D7%A4%D7%9E%D7%9F/en_3f89d41103434d74fabd040a279347e2'],
        painting: './pic10.png',
        smallPainting : './pic10.png',
    },
    "pic11_1": {
        author: ['Malina11'],
        description : [
            "זיוה פרידמן אברהם, אמו של שי-מרדכי פרידמן ז\"ל",
            "לעמוד האישי באתר ״יזכור״"
        ],
        link: ['https://www.izkor.gov.il/%D7%A9%D7%99-%D7%9E%D7%A8%D7%93%D7%9B%D7%99%20%D7%A4%D7%A8%D7%99%D7%93%D7%9E%D7%9F/en_08807b411bb70207fb56d85c1f1602c8'],
        painting: './pic11.png',
        smallPainting : './pic11.png',
    },
    "pic12_1": {
        author: ['Malina222'],
        description : [
            "אסתר כהן, אלמנתו של אברהם כהן ז\"ל",
            "לעמוד האישי באתר ״יזכור״"
        ],
        link: ['https://www.izkor.gov.il/%D7%90%D7%91%D7%A8%D7%94%D7%9D%20%D7%9B%D7%94%D7%9F/en_a3d1d66591de262bac5450a538783603'],
        painting: './pic12.png',
        smallPainting : './pic12.png',
    },
    "pic13_1": {
        author: ['Malina333'],
        description : [
            "לינה אבולניק, אמו של אסף אבולניק ז\"ל",
            "לעמוד האישי באתר ״יזכור״"
        ],
        link: ['https://www.izkor.gov.il/%D7%90%D7%A1%D7%A3%20%D7%90%D7%91%D7%95%D7%9C%D7%A0%D7%99%D7%A7/en_9cffdf20ac2f1ed72e17217337290484'],
        painting: './pic13.png',
        smallPainting : './pic13.png',
    },
    "pic14_1": {
        author: ['Malin12a'],
        description : [
            "רות עדתו, אמה של מיכל עדתו ז\"ל ואלמנתו של עמנואל קהלני ז\"ל",
            "לעמוד האישי של מיכל ז\"ל באתר ״יזכור״",
            "לעמוד האישי של עמנואל ז\"ל באתר ״יזכור״"
        ],
        link: ['https://www.izkor.gov.il/%D7%9E%D7%99%D7%9B%D7%9C%20%D7%A2%D7%93%D7%AA%D7%95/en_d4101ff567207dbfb38280feee6b686c',
            'https://www.izkor.gov.il/%D7%A2%D7%9E%D7%A0%D7%95%D7%90%D7%9C%20%D7%A7%D7%94%D7%9C%D7%A0%D7%99/en_ab9e0511e8eb508eea89264a79e243a3'],
        painting: './pic14.png',
        smallPainting : './pic14.png',
    },
    "pic15_1": {
        author: ['Malina432'],
        description : [
            "כרמלה תירוש, אלמנתו של דוד קשת ז\"ל",
            "לעמוד האישי באתר ״יזכור״"        ],
        link: ['https://www.izkor.gov.il/%D7%93%D7%95%D7%93%20%D7%A7%D7%A9%D7%AA/en_e9fe3a404f7b3b6c84f3290bf707a79b'],
        painting: './pic15.png',
        smallPainting : './pic15.png',
    },
    "pic16_1": {
        author: ['Malin1321a'],
        description : [
            "אליהו בלחסן, אביו של גלעד בלחסן ז\"ל",
            "לעמוד האישי באתר ״יזכור״"        ],
        link: ['https://www.izkor.gov.il/%D7%92%D7%9C%D7%A2%D7%93%20%D7%91%D7%9C%D7%97%D7%A1%D7%9F/en_65d39a03a9b1a9048291af372d2551e7'],
        painting: './pic16.png',
        smallPainting : './pic16.png',
    },
    "pic17_1": {
        author: ['Malina6547'],
        description : [
            "עוזי שחר ולנשטיין, אביו של אלעד ולנשטיין ז\"ל",
            "לעמוד האישי באתר ״יזכור״"        ],
        link: ['https://www.izkor.gov.il/%D7%90%D7%9C%D7%A2%D7%93%20%D7%95%D7%9C%D7%A0%D7%A9%D7%98%D7%99%D7%99%D7%9F/en_823ee2423910e0a5f0aa006d93505a62'],
        painting: './pic17.png',
        smallPainting : './pic17.png',
    },
    "pic18_1": {
        author: ['Malin2221111a'],
        description : [
            "אלה בר שי, אמו של שי (שייקה) ברנשטיין ז\"ל",
            "לעמוד האישי באתר ״יזכור״"        ],
        link: ['https://www.izkor.gov.il/%D7%A9%D7%99%20%D7%91%D7%A8%D7%A0%D7%A9%D7%98%D7%99%D7%99%D7%9F/en_fcaaed7db4afa6083f9b27f0be320236'],
        painting: './pic18.png',
        smallPainting : './pic18.png',
    },
    "pic19_1": {
        author: ['Malinйцйцйa'],
        description : [
            "היבה סלאמה, אחותו של סלאמה סלאמה ז\"ל",
            "לעמוד האישי באתר ״יזכור״"        ],
        link: ['https://www.izkor.gov.il/%D7%A1%D7%9C%D7%90%D7%9E%D7%94%20%D7%A1%D7%9C%D7%90%D7%9E%D7%94/en_ac6f42182c3c180684524153779b1d93'],
        painting: './pic19.png',
        smallPainting : './pic19.png',
    },
    "pic20_1": {
        author: ['Mali1357аааna'],
        description : [
            "רחלי יוסף, אמו של אהוד (אודי) יוסף ז\"ל",
            "לעמוד האישי באתר ״יזכור״"        ],
        link: ['https://www.izkor.gov.il/%D7%90%D7%94%D7%95%D7%93%20%D7%99%D7%95%D7%A1%D7%A3/en_842a85bd6bb342f90fabfed8aeed072f'],
        painting: './pic20.2.png',
        smallPainting : './pic20.2.png',
    },
    "pic21_1": {
        author: ['Malinfhfhhha'],
        description : [
            "טליה להב, אחותו של לירן-אהרון לוין ז\"ל",
            "לעמוד האישי באתר ״יזכור״"        ],
        link: ['https://www.izkor.gov.il/%D7%9C%D7%99%D7%A8%D7%9F-%D7%90%D7%94%D7%A8%D7%95%D7%9F%20%D7%9C%D7%95%D7%99%D7%9F/en_87884ba62c8dd98fbfdc532990cbdc5b'],
        painting: './pic21.png',
        smallPainting : './pic21.png',
    },
    "pic22_1": {
        author: ['Malin1qwtfa'],
        description : [
            "יגאל וגה גרסיה, אחיו של דיאגו-דניאל וגה גרסיה ז\"ל",
            "לעמוד האישי באתר ״יזכור״"        ],
        link: ['https://www.izkor.gov.il/%D7%93%D7%99%D7%90%D7%92%D7%95-%D7%93%D7%A0%D7%99%D7%90%D7%9C%20%D7%95%D7%92%D7%94%20%D7%92%D7%A8%D7%A1%D7%99%D7%94/en_d609e4cd556b1d399131ee1ccc3bccff'],
        painting: './pic22.png',
        smallPainting : './pic22.png',
    },
    "pic23_1": {
        author: ['Malina1111dddd'],
        description : [
            "שירן קנריק, אלמנתו של עופר קנריק ז\"ל",
            "לעמוד האישי באתר ״יזכור״"        ],
        link: ['https://www.izkor.gov.il/%D7%A2%D7%95%D7%A4%D7%A8%20%D7%A7%D7%A0%D7%A8%D7%99%D7%A7/en_6461c91d56730499f4964b3a5b95f905'],
        painting: './pic23.png',
        smallPainting : './pic23.png',
    },
    "pic24_1": {
        author: ['Malinabbbbcccc'],
        description : [
            "אבלין ג'אן, אמו של מאור-משה ג'אן ז\"ל",
            "לעמוד האישי באתר ״יזכור״"        ],
        link: ['https://www.izkor.gov.il/%D7%9E%D7%90%D7%95%D7%A8-%D7%9E%D7%A9%D7%94%20%D7%92\'%D7%90%D7%9F/en_2552bc919b00e79534525bf8e3a7408a'],
        painting: './pic24.png',
        smallPainting : './pic24.png',
    },
    "pic25_1": {
        author: ['Malina7777ffff'],
        description : [
            "אסתר חן - ברזילי, אמו של דודי (להט) ברזילי ז\"ל",
            "לעמוד האישי באתר ״יזכור״"        ],
        link: ['https://www.izkor.gov.il/%D7%93%D7%95%D7%93%D7%99%20%D7%91%D7%A8%D7%96%D7%99%D7%9C%D7%99/en_a2f6afa2b46fe7454a9b7fee0d93f7cc'],
        painting: './pic25.png',
        smallPainting : './pic25.png',
    },
}
